// frontend/src/components/games/memory/MemoryCard.tsx

import { MemoryCardModel } from '../../../hooks/games/useMemoryGame';

interface MemoryCardProps {
  card: MemoryCardModel;
  onFlip: (card: MemoryCardModel) => void;
}

export function MemoryCard({ card, onFlip }: MemoryCardProps) {
  const isRevealed = card.isFlipped || card.isMatched;

  return (
    <button
      type="button"
      className={`memory-card ${isRevealed ? 'flipped' : ''} ${card.isMatched ? 'matched' : ''}`}
      onClick={() => onFlip(card)}
      disabled={isRevealed}
      aria-label={isRevealed ? card.emoji : 'Kapalı kart'}
    >
      <div className="memory-card-inner">
        <div className="memory-card-face memory-card-back">❓</div>
        <div className="memory-card-face memory-card-front">{card.emoji}</div>
      </div>
    </button>
  );
}
